import React from 'react';
import { Box, Grid, Skeleton } from '@mui/material';

const CategoryListSkeleton = ({ count = 5 }: { count?: number }) => {
  const NO_OF_ITEMS_ARRAY: number[] = [];

  for (let i = 1; i <= count; i++) {
    NO_OF_ITEMS_ARRAY.push(i);
  }

  return (
    <Grid container gap={2}>
      {NO_OF_ITEMS_ARRAY.map(() => (
        <Box
          display='flex'
          flexDirection='column'
          gap={1}
          width={150}
          sx={{
            borderRadius: '5px',
            border: (theme) => `1px solid ${theme.palette.borderColor}`,
            bgcolor: (theme) => theme.palette.common.white,
            padding: 2,
          }}
        >
          <Skeleton
            variant='rectangular'
            sx={{
              borderRadius: '2px',
              height: '10px',
              color: (theme) => theme.palette.bgGray.light,
            }}
          ></Skeleton>
        </Box>
      ))}
    </Grid>
  );
};

export default CategoryListSkeleton;
